import { motion, useTransform } from "framer-motion";

export default function StoryProgress({ progress, stages, activeIndex }) {
  const n = stages.length;
  const fill = useTransform(progress, [1 / (2 * n), 1 - 1 / (2 * n)], [0, 1]);

  return (
    <div className="story-rail" data-testid="story-progress" role="presentation">
      <div className="story-rail-track" />
      <motion.div className="story-rail-fill" style={{ scaleY: fill }} />
      {stages.map((st, i) => (
        <span
          key={st.key}
          className={`story-marker ${i === 0 ? "is-red" : ""} ${i <= activeIndex ? "is-on" : ""}`}
          style={{ top: `calc(${i / (n - 1)} * (100% - 14px))` }}
          data-testid={`story-marker-${i + 1}`}
          data-on={i <= activeIndex}
        />
      ))}
    </div>
  );
}
